import { useRedux } from "hooks"
import { useEffect, useState } from "react";
import { loadDllEmployee } from "../redux/workplace/wpActions";
import { TaskStatus, WpSliceData } from "../redux/workplace/wpTypes";
import { createSelector } from "reselect";
import Select, { components, OptionProps, SingleValueProps, DropdownIndicatorProps, IndicatorSeparatorProps } from 'react-select';
import { Utils } from "helpers/utils";
import SelectDropdown from "./SelectDropdown";
import { APIClient } from "api/apiCore";
import * as urls from "../api/urls";


interface SelectDropdownTaskStatusProps {
  onStatusChanged: (status: TaskStatus | null) => void;
  selectedStatus?: TaskStatus | null;
  isDisabled: boolean;
}

const SelectDropdownTaskStatus = ({ selectedStatus, onStatusChanged, isDisabled }: SelectDropdownTaskStatusProps) => {
  const list = Utils.GetTaskStatusForShowInSelect();

  const CustomOption = (props: OptionProps<any>) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span>{Utils.GetTaskStatusIcon(Utils.ToNumber(data.value, -1) ?? -1)}</span>
          <span>{data.label}</span>
        </div>
      </components.Option>
    );
  };

  const CustomSingleValue = (props: SingleValueProps<any>) => {
    const { data } = props;

    return (
      <components.SingleValue {...props}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span>{Utils.GetTaskStatusIcon(Utils.ToNumber(data.value, -1) ?? -1)}</span>
          <span>{data.label}</span>
        </div>
      </components.SingleValue>
    );
  };

  return (
    <SelectDropdown
      isDisabled={isDisabled}
      list={list}
      onValueChanged={(val) => onStatusChanged(Utils.GetTaskStatusFromVal(val))}
      selectedValue={list.find(e => e.value == (selectedStatus ?? TaskStatus.ToDo).toString()) ?? null}
      customOption={CustomOption}
      customValue={CustomSingleValue}      
    />
  )
}

export default SelectDropdownTaskStatus

